(() => {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const PHONE = matchMedia('(max-width: 900px)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const DPR = Math.min(devicePixelRatio || 1, 1.5);

  const ptr = { x: .5, y: .5 }, ptrS = { x: .5, y: .5 };
  let scrollY = 0, lastScroll = 0, frameT = 0;
  addEventListener('pointermove', (e) => { ptr.x = e.clientX / innerWidth; ptr.y = e.clientY / innerHeight; }, { passive: true });

  let lenis = null;
  let jumping = false; // true while a menu / window click is gliding to its chapter, so the collide beat stays out of the way
  if (!RM) {
    // lower lerp = longer glide after each wheel notch; wheelMultiplier tames the
    // big per-notch jumps of desktop mice so the pinned chapters never lurch
    lenis = new Lenis({ lerp: .075, smoothWheel: true, wheelMultiplier: .85, syncTouch: false });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((t) => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
  }
  window.__fon = { scrollTo: (y) => lenis ? lenis.scrollTo(y, { immediate: true }) : scrollTo(0, y), meteor: () => spawnMeteor(frameT) };

  /* ---------- sound: the leoespinoel.com button, the same on all three sites (owner asked 20 Sep) ----------
     Off by default, one click starts the song with a 1s fade, remembered for the session.
     One <audio> element wired through WebAudio: source -> analyser -> gain -> speakers. The analyser feeds the 3x3 matrix
     the track's live frequencies; the gain does the level and the fades (iOS ignores audio.volume). The graph is built on
     the first press, since browsers refuse to start an AudioContext before the visitor has clicked or tapped; for the same
     reason, on a reload with sound remembered, the first click or key anywhere on the page starts it. Hidden tab pauses
     it, back to the tab resumes it. */
  const soundBtn = $('#sound-toggle');
  if (soundBtn) {
    const soundLabel = $('#sound-toggle-label'), dots = $$('.sound-toggle__matrix i', soundBtn);
    const music = new Audio();
    music.loop = true; music.preload = 'none';
    const srcs = [window.FON_ASSETS.music] /* the same song as the Bon Voyage page */;
    const LEVEL = 0.6;
    let ctx = null, analyser = null, gain = null, bins = null, groups = null, on = false, raf = null, missing = false, pauseT = null, startedAt = 0, healed = false;
    const graph = () => {
      if (ctx) return;
      const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
      ctx = new AC();
      analyser = ctx.createAnalyser(); analyser.fftSize = 128; analyser.smoothingTimeConstant = 0.82;
      bins = new Uint8Array(analyser.frequencyBinCount);
      gain = ctx.createGain(); gain.gain.value = 0;
      ctx.createMediaElementSource(music).connect(analyser); analyser.connect(gain); gain.connect(ctx.destination);
      /* most of a track's energy sits low in the spectrum: a log-weighted split over the bottom 60% of the bins keeps all nine dots alive */
      const usable = Math.floor(bins.length * 0.6);
      groups = dots.map((_, i) => {
        const from = Math.floor(usable * Math.pow(i / dots.length, 1.6));
        return [from, Math.max(from + 1, Math.floor(usable * Math.pow((i + 1) / dots.length, 1.6)))];
      });
    };
    const ramp = (to, secs) => { const t = ctx.currentTime; gain.gain.cancelScheduledValues(t); gain.gain.setValueAtTime(gain.gain.value, t); gain.gain.linearRampToValueAtTime(to, t + Math.max(secs, 0.01)); };
    const idle = () => dots.forEach((d) => { d.style.opacity = ''; d.style.transform = ''; });
    const tick = () => {
      analyser.getByteFrequencyData(bins);
      dots.forEach((d, i) => {
        const [from, to] = groups[i];
        let sum = 0; for (let b = from; b < to; b++) sum += bins[b];
        const level = Math.min(1, (sum / (to - from) / 255) * 1.6);
        d.style.opacity = 0.22 + level * 0.78;
        if (!RM) d.style.transform = `scale(${0.55 + level * 0.55})`;
      });
      raf = requestAnimationFrame(tick);
    };
    const setUi = () => {
      soundBtn.setAttribute('aria-pressed', String(on));
      soundBtn.setAttribute('aria-label', missing ? 'Song to come' : on ? 'Turn sound off' : 'Turn sound on');
      soundBtn.dataset.cursor = missing ? 'Song to come' : on ? 'Sound off' : 'Sound on';
      if (!soundBtn.classList.contains('is-loading')) soundLabel.textContent = missing ? 'Soon' : on ? 'On' : 'Off';
    };
    const setLoading = (l) => { soundBtn.classList.toggle('is-loading', l); if (l) { idle(); soundLabel.textContent = 'Loading…'; } else setUi(); };
    const play = () => { const p = music.play(); if (p && p.catch) p.catch((err) => { if (on && err && err.name === 'NotAllowedError') stop(); }); };
    const start = () => {
      if (missing) return;
      graph();
      if (!ctx) { missing = true; soundBtn.setAttribute('aria-disabled', 'true'); setUi(); return; }
      clearTimeout(pauseT);
      ctx.resume();
      on = true; startedAt = performance.now(); healed = false; setLoading(true); setUi();
      play(); ramp(LEVEL, RM ? 0 : 1);
      try { sessionStorage.setItem('fon-sound', '1'); } catch (e) {}
    };
    const stop = () => {
      on = false;
      if (ctx) ramp(0, RM ? 0 : 0.6);
      clearTimeout(pauseT); pauseT = setTimeout(() => music.pause(), RM ? 0 : 620);
      if (raf) cancelAnimationFrame(raf); raf = null;
      setLoading(false); idle();
      try { sessionStorage.removeItem('fon-sound'); } catch (e) {}
    };
    /* try each path in turn; when none loads the button dims and reads "Soon" */
    const tryNext = () => {
      if (!srcs.length) { const was = on; missing = true; if (was) stop(); soundBtn.setAttribute('aria-disabled', 'true'); setUi(); return; }
      music.src = srcs.shift();
      if (on) play();
    };
    music.addEventListener('error', tryNext);
    music.addEventListener('waiting', () => on && setLoading(true));
    /* paused by something other than this button. In the first seconds after a press it is a browser hiccup (seen about once
       in 35 test runs): start it again, once. Later it is the visitor's media key: the button goes to Off rather than pretend */
    music.addEventListener('pause', () => {
      if (!on || document.hidden) return;
      if (!healed && performance.now() - startedAt < 4000) { healed = true; play(); } else stop();
    });
    music.addEventListener('playing', () => { setLoading(false); if (on && !raf) raf = requestAnimationFrame(tick); });
    tryNext();
    soundBtn.addEventListener('click', () => { on ? stop() : start(); });
    document.addEventListener('visibilitychange', () => {
      if (!on) return;
      if (document.hidden) music.pause(); else play();
    });
    let remembered = false;
    try { remembered = sessionStorage.getItem('fon-sound') === '1'; } catch (e) {}
    if (remembered) {
      const arm = (e) => { if (e.type === 'keydown' && e.key === 'Tab') return; document.removeEventListener('pointerdown', arm); document.removeEventListener('keydown', arm); if (!on && !(e.target.closest && e.target.closest('#sound-toggle'))) start(); };
      document.addEventListener('pointerdown', arm); document.addEventListener('keydown', arm);
    }
    setUi();
  }

  /* ---------- stars ---------- */
  const stars = $('#stars'), sctx = stars.getContext('2d');
  let W = 0, H = 0, field = [];
  function seedStars() {
    W = innerWidth; H = innerHeight; measureHole();
    stars.width = W * DPR; stars.height = H * DPR; sctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    const n = PHONE ? 140 : 320;
    field = Array.from({ length: n }, () => {
      const z = .12 + Math.random() ** 1.8 * .88;
      return { x: Math.random() * W, y: Math.random() * H * 1.5, z, r: (.4 + Math.random() * 1.3) * z, a: (.25 + Math.random() * .6) * z, red: Math.random() < .03, ph: Math.random() * 6.28, tw: .4 + Math.random() * 1.2 };
    });
  }
  /* ---------- nebula bloom: colour along the top edge, thinning toward the ring ----------
     Painted at 160px wide on its own canvas that CSS stretches over the viewport: the GPU
     upscale is the blur, so no full-screen drawImage runs per frame. Warm red-brown on the
     left, a cool cyan pocket on the right, each cloud drifting on its own slow loop. The
     clouds move so slowly that repainting every third frame is invisible; the scroll fade
     is a composited opacity so it belongs to the hero only. */
  const bloom = $('#bloom'), bctx = bloom.getContext('2d');
  const BLOOM_W = 160; let bloomH = 100, bloomTick = 0, bloomFade = -1;
  const clouds = [
    { c: '168,54,40',   x: .16, y: -.02, rx: .64, ry: .44, a: .55, sp: .00011, ph: 0.0 },
    { c: '112,52,40',   x: .46, y: -.12, rx: .70, ry: .34, a: .42, sp: .00008, ph: 2.1 },
    { c: '62,158,168',  x: .88, y: .02,  rx: .52, ry: .46, a: .55, sp: .00013, ph: 4.0 },
    { c: '168,54,40',   x: .62, y: .20,  rx: .36, ry: .20, a: .22, sp: .00017, ph: 1.2 },
    { c: '62,158,168',  x: .06, y: .62,  rx: .30, ry: .26, a: .16, sp: .00009, ph: 3.3 },
    { c: '112,52,40',   x: .94, y: .74,  rx: .34, ry: .28, a: .18, sp: .00010, ph: 5.1 },
  ];
  function drawBloom(t, fade) {
    if (fade !== bloomFade) { bloomFade = fade; bloom.style.setProperty('--fade', fade.toFixed(3)); hole.style.setProperty('--fade', fade.toFixed(3)); holeSleep(fade <= 0); }
    if (fade <= 0) return;
    if (bloomTick++ % 3) return;
    bloomH = Math.max(40, Math.round(BLOOM_W * H / W));
    if (bloom.width !== BLOOM_W || bloom.height !== bloomH) { bloom.width = BLOOM_W; bloom.height = bloomH; }
    bctx.clearRect(0, 0, BLOOM_W, bloomH);
    for (const k of clouds) {
      const dx = Math.sin(t * k.sp + k.ph) * .05, dy = Math.cos(t * k.sp * .7 + k.ph) * .03;
      const cx = (k.x + dx) * BLOOM_W, cy = (k.y + dy) * bloomH, rx = k.rx * BLOOM_W, ry = k.ry * bloomH;
      bctx.save();
      bctx.translate(cx, cy); bctx.scale(1, ry / rx);
      const g = bctx.createRadialGradient(0, 0, 0, 0, 0, rx);
      g.addColorStop(0, `rgba(${k.c},${k.a.toFixed(3)})`);
      g.addColorStop(.5, `rgba(${k.c},${(k.a * .45).toFixed(3)})`);
      g.addColorStop(1, `rgba(${k.c},0)`);
      bctx.fillStyle = g; bctx.beginPath(); bctx.arc(0, 0, rx, 0, 6.283); bctx.fill();
      bctx.restore();
    }
  }

  /* ---------- black hole loop: two copies of the clip, handed over while both show the same picture ----------
     The file (tools/hole-loop-build.py) is a loop body followed by a TAIL that repeats the body's first second frame
     for frame. When the playing copy reaches the end of the body, the other copy starts from 0, so for the length of
     the tail both show the same picture. The waiting copy is hidden while it is nudged into step (playbackRate), then
     faded in on top over .3s and the old one parked on frame 0. Same picture under the fade: no seam to see, no
     softening, and no hold like a native `loop` wrap. Factored so the hero and the footer each run their own pair. */
  const HOLE_TAIL = 1, HOLE_FADE = .3;
  function makeHole(el) {
    const vids = $$('video', el);
    vids.forEach((v) => { v.src = PHONE ? window.FON_ASSETS.hole720 : window.FON_ASSETS.hole; });
    let cur = 0, on = false, asleep = false, next = null, raf = 0;
    function tick() {
      raf = 0;
      if (!on || asleep) return;
      const v = vids[cur], n = vids[1 - cur], loopAt = v.duration - HOLE_TAIL;
      if (v.duration) {
        if (!next && v.currentTime >= loopAt - .05) { next = n; n.playbackRate = 1; n.play().catch(() => {}); }
        if (next && n.currentTime > 0 && n.readyState >= 2) {
          const behind = (v.currentTime - loopAt) - n.currentTime; // seconds the waiting copy trails the picture on screen
          if (Math.abs(behind) > .017 && v.currentTime < v.duration - HOLE_FADE - .12 && !v.ended) n.playbackRate = behind > 0 ? 1.3 : .77;
          else {
            n.playbackRate = 1; v.classList.remove('is-top'); n.classList.add('is-on', 'is-top');
            (window.__fon.seams = window.__fon.seams || []).push(+behind.toFixed(3)); // tools/hole-check.mjs: how far out of step each handover was
            cur = 1 - cur; next = null;
            setTimeout(() => { v.classList.remove('is-on'); v.pause(); v.currentTime = 0; }, HOLE_FADE * 1000 + 80);
          }
        }
      }
      raf = requestAnimationFrame(tick);
    }
    function start() {
      on = true;
      vids.forEach((v) => { v.preload = 'auto'; if (v.readyState === 0) v.load(); });
      const v = vids[cur]; v.currentTime = 0; v.classList.add('is-on', 'is-top'); v.play().catch(() => {});
      if (!raf) raf = requestAnimationFrame(tick);
    }
    function sleep(s) {
      if (s === asleep || !on) return;
      asleep = s;
      if (asleep) { vids.forEach((v) => v.pause()); return; }
      vids.forEach((v) => { if (v === next || v.classList.contains('is-on')) v.play().catch(() => {}); });
      if (!raf) raf = requestAnimationFrame(tick);
    }
    if (RM) { vids[0].classList.add('is-on'); vids[0].addEventListener('loadeddata', () => { vids[0].currentTime = .1; }, { once: true }); }
    return { start, sleep };
  }
  const hole = $('#hole'), heroHole = makeHole(hole);
  const holeStart = heroHole.start, holeSleep = heroHole.sleep;
  const footHoleEl = $('#hole-foot'), footHole = makeHole(footHoleEl);

  /* ---------- the hole's gravity, painted on the star canvas under the screen-blended clip ----------
     Measured off assets/hole.mp4 as fractions of the clip's width: the photon ring is a dome, the top half of an
     ellipse standing on the disk line, centre (cx, cy), half-width rx, height ry. The near side of the disk
     flows left to right, so the motes orbit that way and the glint on the ring (the far side, lensed over the
     top) runs right to left. Everything here is scaled by vis = reveal x hero fade, so space bends as the
     hole arrives and relaxes as it scrolls away. A new clip needs these four numbers measured again. */
  const HOLE = { cx: .4853, cy: .507 * 9 / 16, rx: .1605, ry: .158, w: 0, bx: 0, by: 0, x: 0, y: 0, R: 0, Ry: 0, vis: 0, reveal: RM ? 1 : 0 };
  function measureHole() { HOLE.w = hole.offsetWidth; HOLE.bx = hole.offsetLeft; HOLE.by = hole.offsetTop; }
  function placeHole(fade) {
    // pointer parallax at the depth of a middling star, a slow push-in as the hero scrolls away, and the arrival scale
    const ox = RM ? 0 : -(ptrS.x - .5) * W * .016, oy = RM ? 0 : -(ptrS.y - .5) * H * .012;
    const s = (1 + .16 * (1 - fade)) * (.86 + .14 * HOLE.reveal);
    const tf = `translate(calc(-50% + ${ox.toFixed(1)}px), calc(-50% + ${oy.toFixed(1)}px)) scale(${s.toFixed(4)})`;
    if (tf !== HOLE.tf) { HOLE.tf = tf; hole.style.transform = tf; }
    HOLE.x = HOLE.bx + ox + (HOLE.cx - .5) * HOLE.w * s; HOLE.y = HOLE.by + oy + (HOLE.cy - .5 * 9 / 16) * HOLE.w * s;
    HOLE.R = HOLE.rx * HOLE.w * s; HOLE.Ry = HOLE.ry * HOLE.w * s; HOLE.vis = HOLE.reveal * fade;
  }
  // screen blending cannot darken, so the dome's black is painted here: whatever passed behind it is gone
  function drawHoleShadow() {
    sctx.save(); sctx.translate(HOLE.x, HOLE.y); sctx.fillStyle = '#040303';
    for (const [k, a] of [[1, .35], [.975, .6], [.95, 1]]) {
      sctx.globalAlpha = a * HOLE.vis; sctx.beginPath();
      sctx.ellipse(0, 0, HOLE.R * k, HOLE.Ry * k, 0, Math.PI, 0); sctx.ellipse(0, 0, HOLE.R * k, HOLE.Ry * .1 * k, 0, 0, Math.PI); sctx.fill();
    }
    sctx.restore();
  }
  // a glint runs the photon ring every 7s, over a slow breathing glow
  function drawRingGlint(t) {
    sctx.save(); sctx.translate(HOLE.x, HOLE.y); sctx.globalCompositeOperation = 'lighter'; sctx.lineCap = 'round';
    const breathe = (.05 + .04 * Math.sin(t * .0011)) * HOLE.vis;
    sctx.strokeStyle = `rgba(255,214,180,${breathe.toFixed(3)})`; sctx.lineWidth = 6;
    sctx.beginPath(); sctx.ellipse(0, 0, HOLE.R, HOLE.Ry, 0, Math.PI, 0); sctx.stroke();
    const u = (t % 7000) / 4200;
    if (u < 1) {
      const e = u * u * (3 - 2 * u), head = -e * Math.PI, env = Math.sin(u * Math.PI) * HOLE.vis; // 0 -> -PI: right foot, over the top, left foot
      for (let j = 0; j < 5; j++) {
        const a0 = Math.min(0, head + (j + 1) * .09), a1 = Math.min(0, head + j * .09);
        if (a0 === a1) continue;
        sctx.strokeStyle = `rgba(255,240,222,${(env * (1 - j / 5) * .85).toFixed(3)})`; sctx.lineWidth = 2.4 - j * .3;
        sctx.beginPath(); sctx.ellipse(0, 0, HOLE.R, HOLE.Ry, 0, a0, a1, true); sctx.stroke();
      }
      const hx = Math.cos(head) * HOLE.R, hy = Math.sin(head) * HOLE.Ry, g = sctx.createRadialGradient(hx, hy, 0, hx, hy, 10);
      g.addColorStop(0, `rgba(255,246,232,${(env * .75).toFixed(3)})`); g.addColorStop(1, 'rgba(255,246,232,0)');
      sctx.fillStyle = g; sctx.beginPath(); sctx.arc(hx, hy, 10, 0, 6.283); sctx.fill();
    }
    sctx.restore();
  }
  // dust in the disk plane: Kepler-fast near the hole, drifting inward until it is lost against the disk
  const MOTE_TILT = .2;
  const newMote = (seed) => ({ a: seed ? 1.2 + Math.random() * 1.8 : 2.7 + Math.random() * .5, th: Math.random() * 6.283, r: .6 + Math.random() * 1.1, al: .35 + Math.random() * .55 });
  const motes = Array.from({ length: PHONE ? 14 : 30 }, () => newMote(true));
  let moteT = 0;
  function stepMotes(t) {
    const dt = Math.min(.05, (t - (moteT || t)) / 1000); moteT = t;
    for (let i = 0; i < motes.length; i++) {
      const m = motes[i];
      m.th -= dt * 1.15 / (m.a * Math.sqrt(m.a)); m.a -= dt * .035 * (1 + 1.5 / m.a);
      if (m.a < 1.06) motes[i] = newMote(false);
    }
  }
  function drawMotes(near) {
    sctx.save(); sctx.translate(HOLE.x, HOLE.y); sctx.globalCompositeOperation = 'lighter'; sctx.lineCap = 'round';
    sctx.strokeStyle = 'rgb(255,216,176)'; sctx.fillStyle = 'rgb(255,240,220)';
    for (const m of motes) {
      if ((Math.sin(m.th) > 0) !== near) continue;
      const env = Math.min(1, (3.2 - m.a) * 2.5) * Math.min(1, (m.a - 1.06) * 5) * m.al * HOLE.vis;
      if (env <= 0) continue;
      const rx = m.a * HOLE.R, ry = rx * MOTE_TILT, tail = Math.min(.5, (8 + 20 / m.a) / rx); // a short tail, longer where it is fast
      sctx.globalAlpha = env * .45; sctx.lineWidth = m.r * 1.3;
      sctx.beginPath(); sctx.ellipse(0, 0, rx, ry, 0, m.th, m.th + tail); sctx.stroke();
      sctx.globalAlpha = env;
      sctx.beginPath(); sctx.arc(Math.cos(m.th) * rx, Math.sin(m.th) * ry, m.r * 1.2, 0, 6.283); sctx.fill();
    }
    sctx.restore();
  }

  /* ---------- meteors: a streak every 3–5 s across the top third, hero only ----------
     Long tail with a soft outer glow and a bright head; one in four comes as a pair.
     Each one is flown step by step under the hole's pull, so its path bends, the tail follows the bend,
     and one that comes close speeds up, stops fading and falls in behind the dome. */
  const meteors = []; let nextMeteor = 1800;
  window.__fon.hole = HOLE; window.__fon.meteors = meteors; // tools/hole-check.mjs reads the geometry and flies its own meteor
  function spawnMeteor(now, delay = 0) {
    const right = Math.random() < .5, ang = (14 + Math.random() * 18) * Math.PI / 180;
    const len = 160 + Math.random() * 140, speed = 700 + Math.random() * 400;
    const travel = 320 + Math.random() * 300;
    const x0 = W * (.06 + Math.random() * .88), y0 = H * (.02 + Math.random() * .14);
    meteors.push({ x: x0, y: y0, vx: Math.cos(ang) * (right ? 1 : -1) * speed, vy: Math.sin(ang) * speed, len, travel, dist: 0, age: 0, last: 0, trail: [[x0, y0, 0]], t0: now + delay });
  }
  function drawMeteors(now, fade) {
    if (fade > .2 && now > nextMeteor) {
      spawnMeteor(now); if (Math.random() < .25) spawnMeteor(now, 250 + Math.random() * 300);
      nextMeteor = now + 3000 + Math.random() * 2000;
    }
    const pull = HOLE.vis > .01 ? .5 * HOLE.R * 810000 * HOLE.vis : 0, soft = (HOLE.R * .45) ** 2;
    sctx.lineCap = 'round'; sctx.lineJoin = 'round';
    for (let i = meteors.length - 1; i >= 0; i--) {
      const m = meteors[i];
      if (now < m.t0) continue;
      let left = Math.min(.05, (now - (m.last || now)) / 1000), gone = false; m.last = now;
      // 4ms sub-steps: a close pass is fast and tightly curved, and whole-frame steps turned it into corners
      while (left > 1e-5 && !gone) {
        const h = Math.min(left, .004); left -= h;
        let near = false;
        if (pull) {
          const gx = HOLE.x - m.x, gy = HOLE.y - m.y, r2 = gx * gx + gy * gy, r = Math.sqrt(r2), a = pull / (r2 + soft) * h;
          m.vx += gx / r * a; m.vy += gy / r * a;
          near = r < HOLE.R * 2.2; gone = r < HOLE.R * .5;
        }
        const step = Math.hypot(m.vx, m.vy) * h;
        m.x += m.vx * h; m.y += m.vy * h; m.dist += step;
        if (!near) m.age += step; // caught by the hole it stops ageing, so it does not fade out mid-fall
        if (m.dist - m.trail[m.trail.length - 1][2] > 8) m.trail.push([m.x, m.y, m.dist]);
      }
      while (m.trail.length > 2 && m.dist - m.trail[1][2] > m.len) m.trail.shift();
      const p = (m.age || 0) / m.travel;
      if (gone || p >= 1) { meteors.splice(i, 1); continue; }
      const env = Math.min(1, p * 5) * Math.min(1, (1 - p) * 2) * fade, pts = m.trail, n = pts.length, hx = m.x, hy = m.y;
      // soft glow under the streak, then the streak itself, in six strokes brightening toward the head
      for (let g = 0; g < 6; g++) {
        const a = Math.floor(g * n / 6), b = Math.floor((g + 1) * n / 6), f = (g + 1) / 6;
        if (b <= a && g < 5) continue;
        sctx.beginPath(); sctx.moveTo(pts[a][0], pts[a][1]);
        for (let j = a + 1; j <= b && j < n; j++) sctx.lineTo(pts[j][0], pts[j][1]);
        if (g === 5) sctx.lineTo(hx, hy);
        sctx.globalAlpha = env * .35 * f; sctx.strokeStyle = 'rgb(255,225,205)'; sctx.lineWidth = 6; sctx.stroke();
        sctx.globalAlpha = env * f * f; sctx.strokeStyle = 'rgb(255,244,232)'; sctx.lineWidth = 2; sctx.stroke();
      }
      sctx.globalAlpha = 1;
      // head: a bright core with a halo
      const hg = sctx.createRadialGradient(hx, hy, 0, hx, hy, 9);
      hg.addColorStop(0, `rgba(255,252,246,${env.toFixed(3)})`); hg.addColorStop(.3, `rgba(255,240,225,${(env * .6).toFixed(3)})`); hg.addColorStop(1, 'rgba(255,240,225,0)');
      sctx.fillStyle = hg; sctx.beginPath(); sctx.arc(hx, hy, 9, 0, 6.283); sctx.fill();
    }
  }

  const STAR_STEPS = 24, starDots = Array.from({ length: STAR_STEPS }, () => []), starOdd = [];
  function drawStars(t) {
    sctx.clearRect(0, 0, W, H);
    const heroFade = Math.max(0, 1 - scrollY / (H * 1.1));
    drawBloom(t, heroFade);
    placeHole(heroFade);
    const px = (ptrS.x - .5) * W, py = (ptrS.y - .5) * H;
    // point-mass lens: a star at distance r from the hole is seen at (r + sqrt(r^2 + 4E^2)) / 2, never inside the
    // Einstein radius E (set just outside the photon ring), and is stretched along the ring by the same ratio,
    // so stars slide round the dome as the pointer or the scroll moves the sky, and the closest smear into arcs
    const lensOn = HOLE.vis > .01, E = HOLE.R * 1.07 * HOLE.vis, E4 = 4 * E * E;
    // 320 separate fills a frame was the hero's biggest drawing cost. Dots are sorted into 24 brightness steps (finer
    // than the eye sees in a twinkle) and each step is filled as one path; only the few smeared stars are stroked singly.
    for (let b = 0; b < STAR_STEPS; b++) starDots[b].length = 0;
    starOdd.length = 0;
    for (const s of field) {
      const tw = RM ? 1 : .7 + .3 * Math.sin(t * .001 * s.tw + s.ph);
      let x = s.x - px * s.z * .05;
      let y = (s.y - py * s.z * .04 - scrollY * s.z * .18) % (H * 1.5); if (y < 0) y += H * 1.5;
      y -= H * .25;
      let k = 1, r2 = 0, a0 = 0;
      if (lensOn) {
        const dx = x - HOLE.x, dy = y - HOLE.y, r = Math.hypot(dx, dy) || .01;
        r2 = (r + Math.sqrt(r * r + E4)) / 2; k = r2 / r; x = HOLE.x + dx * k; y = HOLE.y + dy * k;
        if (k > 1.12) a0 = Math.atan2(dy, dx);
      }
      if (x < -40 || x > W + 40 || y < -40 || y > H + 40) continue;
      // the more a star is magnified the faster it races round the ring when the sky shifts, which read as flicker:
      // past k = 2.2 it fades, and by 3.7 it is gone
      const al = Math.min(1, s.a * tw * (1 + .3 * (k - 1))) * (k > 2.2 ? Math.max(0, 1 - (k - 2.2) / 1.5) : 1);
      if (al <= .01) continue;
      // the smear is the length added to the dot, so it grows from nothing: no jump where a dot becomes an arc
      const smear = k > 1.12 ? Math.min(22, 2 * s.r * (Math.pow(k, 1.6) - 1.2)) : 0;
      if (smear > .5 || s.red) starOdd.push(x, y, smear > .5 ? s.r / Math.sqrt(k) : s.r, smear > .5 ? al * (.55 + .45 / k) : al, s.red ? 1 : 0, smear > .5 ? smear / (2 * r2) : 0, r2, a0);
      else starDots[Math.min(STAR_STEPS - 1, (al * STAR_STEPS) | 0)].push(x, y, s.r);
    }
    sctx.fillStyle = '#F4F1EC';
    for (let b = 0; b < STAR_STEPS; b++) {
      const d = starDots[b]; if (!d.length) continue;
      sctx.globalAlpha = (b + .5) / STAR_STEPS; sctx.beginPath();
      for (let j = 0; j < d.length; j += 3) { sctx.moveTo(d[j] + d[j + 2], d[j + 1]); sctx.arc(d[j], d[j + 1], d[j + 2], 0, 6.283); }
      sctx.fill();
    }
    sctx.lineCap = 'round';
    for (let j = 0; j < starOdd.length; j += 8) {
      const ink = starOdd[j + 4] ? '#E8392F' : '#F4F1EC'; sctx.globalAlpha = starOdd[j + 3];
      if (starOdd[j + 5]) { sctx.strokeStyle = ink; sctx.lineWidth = starOdd[j + 2] * 2; sctx.beginPath(); sctx.arc(HOLE.x, HOLE.y, starOdd[j + 6], starOdd[j + 7] - starOdd[j + 5], starOdd[j + 7] + starOdd[j + 5]); sctx.stroke(); }
      else { sctx.fillStyle = ink; sctx.beginPath(); sctx.arc(starOdd[j], starOdd[j + 1], starOdd[j + 2], 0, 6.283); sctx.fill(); }
    }
    sctx.globalAlpha = 1;
    if (!RM) drawMeteors(t, heroFade);
    if (lensOn) {
      if (!RM) { stepMotes(t); drawMotes(false); }
      drawHoleShadow();
      if (!RM) { drawMotes(true); drawRingGlint(t); }
    }
  }

  /* ---------- orbit ---------- */
  const orbit = $('#orbit'), sys = $('#sys'), spark = $('#spark');
  const windows = $$('[data-window]');
  let autoSpin = 0, dragSpin = 0, scrollSpin = 0, vel = 0, dragging = false, dragDist = 0, lastX = 0, pressTarget = null;
  orbit.addEventListener('pointerdown', (e) => { dragging = true; dragDist = 0; lastX = e.clientX; pressTarget = e.target.closest('[data-window]'); orbit.classList.add('is-drag'); orbit.setPointerCapture(e.pointerId); });
  orbit.addEventListener('pointermove', (e) => { if (!dragging) return; const dx = e.clientX - lastX; lastX = e.clientX; dragDist += Math.abs(dx); vel = dx * .35; dragSpin += dx * .35; });
  orbit.addEventListener('pointerup', (e) => {
    dragging = false; orbit.classList.remove('is-drag');
    // setPointerCapture retargets the mouse's click event to #orbit, so a plain
    // click on a window anchor never reaches its own listener — drive navigation
    // from here instead, using whichever window the press started on.
    if (pressTarget && dragDist <= 6) goTo(pressTarget.getAttribute('href'), e);
    pressTarget = null;
  });
  orbit.addEventListener('pointercancel', () => { dragging = false; orbit.classList.remove('is-drag'); pressTarget = null; });
  windows.forEach((w) => w.addEventListener('click', (e) => { if (dragDist > 6) { e.preventDefault(); return; } goTo(w.getAttribute('href'), e); }));
  windows.forEach((w) => w.addEventListener('pointerenter', () => glitch($('.gl', w), 420)));

  function tickOrbit() {
    if (!RM) {
      if (!dragging) { autoSpin += .06; vel *= .93; dragSpin += vel; }
      const spin = autoSpin + dragSpin + scrollSpin;
      const tilt = (ptrS.y - .5) * -14;
      sys.style.setProperty('--spin', spin + 'deg');
      sys.style.setProperty('--tilt', tilt + 'deg');
      spark.style.setProperty('--sa', (-spin * 1.6) + 'deg');
      // the spark's angle in the system is spin + sa = -.6 spin; hide it on the far side like the ring
      const sparkFront = (Math.cos(spin * -.6 * Math.PI / 180) + 1) / 2;
      spark.style.opacity = Math.max(0, Math.min(1, (sparkFront - .3) / .25)).toFixed(3);
      for (let i = 0; i < windows.length; i++) {
        const a = ((i * 72 + spin) % 360) * Math.PI / 180;
        windows[i].style.setProperty('--front', ((Math.cos(a) + 1) / 2).toFixed(3));
      }
    }
  }

  /* ---------- loop ---------- */
  // past 2.1 viewports the chapters have wiped over the hero and the footer is opaque,
  // so nothing the hero loop paints can be seen: skip it and give the frame to the scroll
  const HERO_GONE = 2.1;
  function frame(t) {
    frameT = t;
    ptrS.x += (ptr.x - ptrS.x) * .06; ptrS.y += (ptr.y - ptrS.y) * .06;
    scrollY = lenis ? lenis.scroll : window.scrollY;
    const gone = scrollY > H * HERO_GONE && lastScroll > H * HERO_GONE;
    lastScroll = scrollY;
    if (gone) return;
    drawStars(t); tickOrbit();
  }
  addEventListener('resize', () => { seedStars(); fitWordmark(); });
  seedStars();
  if (RM) { drawStars(0); windows.forEach((w) => w.style.setProperty('--front', '1')); } else gsap.ticker.add((t) => frame(t * 1000));

  /* ---------- glitch ---------- */
  function glitch(el, dur = 700) {
    if (RM || !el || el.classList.contains('is-glitch')) return;
    el.classList.add('is-glitch');
    const t0 = performance.now();
    (function step() {
      const p = (performance.now() - t0) / dur;
      if (p >= 1) { el.classList.remove('is-glitch'); ['--t1', '--b1', '--x1', '--t2', '--b2', '--x2'].forEach((k) => el.style.removeProperty(k)); return; }
      const amp = (1 - p) ** 2, t1 = Math.random() * 80, t2 = Math.random() * 80;
      el.style.setProperty('--t1', t1 + '%'); el.style.setProperty('--b1', (100 - t1 - 6 - Math.random() * 18) + '%');
      el.style.setProperty('--t2', t2 + '%'); el.style.setProperty('--b2', (100 - t2 - 6 - Math.random() * 18) + '%');
      el.style.setProperty('--x1', ((Math.random() - .5) * 28 * amp) + 'px');
      el.style.setProperty('--x2', ((Math.random() - .5) * 28 * amp) + 'px');
      setTimeout(step, 40);
    })();
  }
  $$('.chapter__head .gl').forEach((el) => el.addEventListener('pointerenter', () => glitch(el, 800)));

  /* ---------- wordmark ---------- */
  const wm = $('#wordmark');
  function fitWordmark() {
    wm.style.fontSize = '100px';
    const cs = getComputedStyle(wm.parentElement);
    const avail = wm.parentElement.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    wm.style.fontSize = Math.floor(100 * avail / wm.scrollWidth * .99) + 'px';
  }

  /* ---------- loader ---------- */
  const loader = $('#loader'), glyph = $('#glyph'), gctx = glyph.getContext('2d'), countEl = $('.loader__count');
  /* the heart loader always plays, on every visit including a plain reload, and it always comes first: the heart
     counts up on plain black, and only when it bursts do the sky, the black hole and the title page ease in. Arriving
     through the bon-voyage site's black hole (?hole=1) is the same sequence: that trip ends on black, this page opens
     on the same black, so the flag is just dropped from the address once read. Desktop used to take a shortcut there
     (loader see-through, sky and hole already open behind it, as a shot already in progress); the owner saw it as the
     heart and the title page arriving at the same time and asked for the heart first (20 Sep). Phones never had it. */
  if (new URLSearchParams(location.search).has('hole')) history.replaceState(null, '', location.pathname + location.hash);
  function buildGlyph() {
    const cols = 34, rows = 24, cw = 10, ch = 13.5, cells = [], byRow = new Map();
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      const x = (c / (cols - 1)) * 2.8 - 1.4, y = 1.25 - (r / (rows - 1)) * 2.55;
      if ((x * x + y * y - 1) ** 3 - x * x * y * y * y <= 0) {
        const cell = { c, r, ch: '/', d: Math.hypot(x, y - .15) + Math.random() * .45 };
        cells.push(cell);
        if (!byRow.has(r)) byRow.set(r, []);
        byRow.get(r).push(cell);
      }
    }
    /* "143" appears here and there, never tiled solid: each contiguous stretch of columns in
       a row gets one 1,4,3 group (two, on stretches long enough to fit both with room to
       spare), placed most of the time, so it reads clearly against the "/" field */
    const tryStamp = (arr) => {
      if (arr.length >= 3 && Math.random() < .85) {
        const start = Math.floor(Math.random() * (arr.length - 2));
        arr[start].ch = '1'; arr[start + 1].ch = '4'; arr[start + 2].ch = '3';
      }
    };
    byRow.forEach(rowCells => {
      rowCells.sort((a, b) => a.c - b.c);
      let runStart = 0;
      for (let i = 1; i <= rowCells.length; i++) {
        const broke = i === rowCells.length || rowCells[i].c !== rowCells[i - 1].c + 1;
        if (!broke) continue;
        const run = rowCells.slice(runStart, i);
        if (run.length >= 7) {
          const mid = Math.floor(run.length / 2);
          tryStamp(run.slice(0, mid));
          tryStamp(run.slice(mid));
        } else {
          tryStamp(run);
        }
        runStart = i;
      }
    });
    cells.sort((a, b) => a.d - b.d);
    glyph.width = 340 * DPR; glyph.height = 330 * DPR; gctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    return { cells, cw, ch, cols, rows };
  }
  function drawGlyph(g, p) {
    gctx.clearRect(0, 0, 340, 330);
    gctx.font = `500 12px 'Geist Mono', monospace`; gctx.textBaseline = 'middle'; gctx.textAlign = 'center'; gctx.fillStyle = '#C11B15';
    const n = Math.floor(p * g.cells.length), ox = (340 - g.cols * g.cw) / 2 + g.cw / 2, oy = (330 - g.rows * g.ch) / 2 + g.ch / 2;
    for (let i = 0; i < n; i++) {
      const cell = g.cells[i];
      gctx.fillText(cell.ch, ox + cell.c * g.cw, oy + cell.r * g.ch);
    }
  }
  gsap.set(['.brand', '.menu', '.chrome-end .sound-toggle', '.pill', '.hint'], { y: 12 });
  gsap.set(orbit, { scale: .6, autoAlpha: 0 });
  function revealChrome(intro) {
    const tl = gsap.timeline();
    tl.to('#stars', { opacity: 1, duration: 1.4, ease: 'power2.out' }, 0)
      .to('#bloom', { '--reveal': 1, duration: 1.4, ease: 'power2.out' }, 0);
    // the hole arrives slower than the rest: it swells into place while the stars are pushed out round it
    tl.add(holeStart, 0).to(HOLE, { reveal: 1, duration: 2.8, ease: 'power3.out', onUpdate: () => hole.style.setProperty('--reveal', HOLE.reveal.toFixed(3)) }, .2);
    tl.to(orbit, { scale: 1, autoAlpha: 1, duration: 1.8, ease: 'expo.out' }, .1)
      .to(['.brand', '.menu', '.chrome-end .sound-toggle', '.pill', '.hint'], { opacity: 1, y: 0, duration: 1, ease: 'expo.out', stagger: .12 }, .6);
    if (!intro) tl.progress(1);
    return tl;
  }
  async function intro() {
    await document.fonts.ready;
    if (RM) { loader.remove(); revealChrome(false); return; }
    const g = buildGlyph(), state = { p: 0 };
    gsap.timeline()
      .to(state, { p: 1, duration: 1.8, ease: 'power1.inOut', delay: .3, onUpdate() { drawGlyph(g, state.p); countEl.textContent = '/' + String(Math.round(state.p * 100)).padStart(2, '0'); } })
      .to({}, { duration: .5, onUpdate() { drawGlyph(g, 1); } })
      .add(() => revealChrome(true), '>-0.1')
      .to(countEl, { opacity: 0, duration: .4 }, '<')
      .to(glyph, { scale: 1.5, opacity: 0, duration: .9, ease: 'expo.in' }, '<')
      .to(loader, { opacity: 0, duration: .6 }, '<0.35')
      .add(() => loader.remove());
  }
  intro();

  /* ---------- scroll choreography ---------- */
  gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
    ScrollTrigger.create({ trigger: '.hero', start: 'top top', end: 'bottom top', pin: '.hero__stage', pinSpacing: false, onUpdate: (st) => { scrollSpin = st.progress * 360; } });
    ScrollTrigger.create({ trigger: '.hero', start: 'top top', end: '+=200', onLeave: () => gsap.to('#hint', { opacity: 0, duration: .6 }), onEnterBack: () => gsap.to('#hint', { opacity: 1, duration: .6 }) });

    // the menu's line row follows the chapter on screen
    let activeLine = null;
    const lineLinks = $$('[data-line-link]');
    function setLine(id) {
      activeLine = id;
      lineLinks.forEach((a) => { if (a.dataset.lineLink === id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    }

    $$('.chapter').forEach((ch) => {
      const stage = $('.chapter__stage', ch), plane = $('.plane', ch), track = $('.track', ch), head = $('.chapter__head .gl', ch);
      let glitched = false;
      const dist = () => Math.max(0, track.scrollWidth - innerWidth);
      // on phone the heading is absolute inside the track, so slide the cards and leave the track (and heading) still
      const slide = PHONE ? $$('.card', track) : track;
      // range = the whole 300vh section (end 'bottom top'), so this stage stays pinned while the next chapter wipes over it
      // a short scrub lets the wipe and the slide glide over dropped frames instead of stepping with them
      gsap.timeline({ scrollTrigger: { trigger: ch, start: 'top top', end: 'bottom top', pin: stage, pinSpacing: false, scrub: .35, invalidateOnRefresh: true,
        onToggle(st) { if (st.isActive) setLine(ch.id); else if (activeLine === ch.id) setLine(null); },
        onUpdate(st) { if (!glitched && st.progress > .22) { glitched = true; glitch(head, 900); } if (st.progress < .05) glitched = false; } } })
        .fromTo(plane, { clipPath: 'polygon(0 118%, 100% 105%, 100% 200%, 0 200%)' }, { clipPath: 'polygon(0 18%, 100% 5%, 100% 100%, 0 100%)', ease: 'none', duration: .7 }, 0)
        .fromTo(plane, { clipPath: 'polygon(0 18%, 100% 5%, 100% 100%, 0 100%)' }, { clipPath: 'polygon(0 0%, 100% 0%, 100% 100%, 0 100%)', ease: 'none', duration: .2 }, .7)
        .fromTo(slide, { x: 0 }, { x: () => -dist(), ease: 'none', duration: 1.4 }, 1)
        .to({}, { duration: .6 });
    });

    /* collide: leaving the orbit plays a 2.75s timed beat (same pace as the bon-voyage site's NOT JUST A TEE decode).
       Scroll is held while it runs; under the black cover the page jumps to the Classic fully wiped in, so the phrase
       lifts straight off the first line. Once per page load; menu and window jumps skip it. */
    (() => {
      const box = $('#collide'), text = $('#collide-text'), flash = $('#collide-flash'), classic = $('#classic');
      if (!box || !classic || !lenis) return;
      // phone: four lines so the type stays big, and the two words meet top to bottom instead of side to side
      const LINES = PHONE ? [['WHERE'], ['MISSION'], ['AND', 'STYLE'], ['COLLIDE.']] : [['WHERE', 'MISSION'], ['AND', 'STYLE'], ['COLLIDE.']], HIT = { MISSION: 'l', STYLE: 'r' };
      const ABC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', rnd = (a, b) => a + Math.random() * (b - a);
      const hitL = [], hitR = [], rest = [];
      LINES.forEach((words) => {
        const ln = document.createElement('span'); ln.className = 'ln';
        words.forEach((word, wi) => {
          if (wi) ln.append(' ');
          const w = document.createElement('span'); w.className = 'w';
          [...word].forEach((c) => {
            const ch = document.createElement('span'); ch.className = 'ch' + (HIT[word] ? ' hit' : ''); ch.textContent = c; ch.dataset.c = c;
            (HIT[word] === 'l' ? hitL : HIT[word] === 'r' ? hitR : rest).push(ch); w.append(ch);
          });
          ln.append(w);
        });
        text.append(ln);
      });
      const chars = [...hitL, ...hitR, ...rest];
      let fs = 100;
      // the longest line runs edge to edge (88% of the width), and the block stays inside 80% of the height
      function fit() {
        gsap.set([text, ...chars], { clearProps: 'all' });
        chars.forEach((ch) => { ch.textContent = ch.dataset.c; });
        text.style.fontSize = '100px';
        const w = Math.max(...$$('.ln', text).map((l) => l.getBoundingClientRect().width));
        fs = 100 * innerWidth * .88 / w; text.style.fontSize = fs + 'px';
        const h = text.getBoundingClientRect().height, maxH = innerHeight * .8;
        if (h > maxH) { fs *= maxH / h; text.style.fontSize = fs + 'px'; }
        chars.forEach((ch) => { ch.style.width = ch.getBoundingClientRect().width.toFixed(2) + 'px'; });
      }
      const union = (els) => { const r = els.map((e) => e.getBoundingClientRect()); return { l: Math.min(...r.map((x) => x.left)), r: Math.max(...r.map((x) => x.right)), t: Math.min(...r.map((x) => x.top)), b: Math.max(...r.map((x) => x.bottom)) }; };

      let played = false, busy = false;
      function play(st) {
        played = busy = true;
        lenis.stop(); document.documentElement.classList.add('is-collide-locked'); box.classList.add('is-on');
        fit();
        // collision pose: MISSION's right edge and STYLE's left edge meet at the centre of the screen, at mid-height
        // (phone: MISSION's foot and STYLE's head meet there instead, both centred across the width)
        const m = union(hitL), s = union(hitR), cx = innerWidth / 2, cy = innerHeight / 2, gap = fs * .03;
        const mDx = PHONE ? cx - (m.l + m.r) / 2 : cx - gap - m.r, mDy = PHONE ? cy - gap - m.b : cy - (m.t + m.b) / 2;
        const sDx = PHONE ? cx - (s.l + s.r) / 2 : cx + gap - s.l, sDy = PHONE ? cy + gap - s.t : cy - (s.t + s.b) / 2;
        const ax = PHONE ? 'y' : 'x', far = PHONE ? innerHeight : innerWidth; // the axis the words travel along
        const from = (d, sign) => (PHONE ? { x: d.x, y: d.y + sign * far } : { x: d.x + sign * far, y: d.y });
        const burst = (d, sign) => { const along = sign * rnd(.1, PHONE ? 1.3 : .7) * fs, across = rnd(-1, 1) * fs * (PHONE ? 1.4 : 1); return PHONE ? { x: d.x + across, y: d.y + along } : { x: d.x + along, y: d.y + across }; };
        const M = { x: mDx, y: mDy }, S = { x: sDx, y: sDy };
        const landing = () => st.start + (st.end - st.start) * (.95 / 3); // wipe done, heading up, slide not yet started
        const land = () => { if (Math.abs(lenis.scroll - landing()) > 2) lenis.scrollTo(landing(), { immediate: true, force: true }); };
        const T = .6; // the moment of impact
        const tl = gsap.timeline({ onComplete() {
          box.classList.remove('is-on'); document.documentElement.classList.remove('is-collide-locked');
          lenis.start(); busy = false; box.onclick = null;
        } });
        box.onclick = () => tl.timeScale(4); // a click hurries it along
        window.__fon.collide = tl; // capture tools pause and step this
        tl.set(rest, { opacity: 0 })
          .set(hitL, from(M, -1))
          .set(hitR, from(S, 1))
          .to(box, { autoAlpha: 1, duration: .2, ease: 'power1.out' }, 0)
          .to(hitL, { [ax]: M[ax], duration: T - .15, ease: 'power3.in' }, .15)
          .to(hitR, { [ax]: S[ax], duration: T - .15, ease: 'power3.in' }, .15)
          .add(land, .3)
          // impact: flash, shake, and every letter is thrown back the way it came
          .fromTo(flash, { scale: 0, opacity: 1 }, { scale: 1, opacity: 0, duration: .9, ease: 'power3.out' }, T)
          .to(text, { keyframes: { x: [0, -fs * .09, fs * .07, -fs * .04, fs * .02, 0] }, duration: .34, ease: 'none' }, T);
        hitL.forEach((ch) => tl.to(ch, { ...burst(M, -1), rotation: rnd(-80, 80), duration: .3, ease: 'expo.out' }, T));
        hitR.forEach((ch) => tl.to(ch, { ...burst(S, 1), rotation: rnd(-80, 80), duration: .3, ease: 'expo.out' }, T));
        // the letters fall into their places in the phrase while the other words decode around them
        tl.to([...hitL, ...hitR], { x: 0, y: 0, rotation: 0, duration: .55, ease: 'expo.inOut', stagger: .012 }, T + .28);
        rest.forEach((ch, i) => {
          const at = T + .4 + i * .02, final = ch.dataset.c;
          tl.set(ch, { opacity: 1 }, at)
            .to({}, { duration: .45, onUpdate() { ch.textContent = this.progress() < 1 && final !== '.' ? ABC[Math.floor(Math.random() * 26)] : final; } }, at);
        });
        // the finished phrase (complete at ~T + 1.15) holds for .6s (2.75s in all; owner asked 18 Sep for the pause .2s
        // longer than the original 2.55s), then lifts out and the Classic is underneath
        tl.add(land, T + 1.6)
          .to(text, { yPercent: -12, autoAlpha: 0, duration: .4, ease: 'power3.in' }, T + 1.75)
          .add(() => glitch($('.chapter__head .gl', classic), 900), '>-0.25')
          .to(box, { autoAlpha: 0, duration: .25 }, '<');
      }
      const born = performance.now();
      ScrollTrigger.create({ trigger: classic, start: 'top top', end: 'bottom top',
        onEnter(st) {
          // only a real scroll down out of the orbit: not a reload further down the page, not a menu jump
          if (played || busy || jumping || $('#loader') || performance.now() - born < 1200 || lenis.scroll > st.start + innerHeight * .6) return;
          play(st);
        } });
      let rz; addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => { if (!busy) fit(); }, 200); });
      document.fonts.ready.then(fit);
    })();

    gsap.to('.wordmark', { clipPath: 'inset(0% 0 0 0)', duration: 1.6, ease: 'expo.out', scrollTrigger: { trigger: 'footer', start: 'top 85%', once: true } });
    gsap.to('.foot__links', { opacity: 1, y: 0, duration: 1.2, delay: .5, ease: 'expo.out', scrollTrigger: { trigger: 'footer', start: 'top 85%', once: true } });
    ScrollTrigger.create({ trigger: 'footer', start: 'top 85%', once: true, onEnter: () => {
      footHole.start();
      gsap.to(footHoleEl, { '--reveal': 1, duration: 2, ease: 'power2.out', delay: .2 });
    } });
  });

  /* ---------- panels ---------- */
  const scrim = $('#scrim'), panel = $('#panel'), bag = $('#bag');
  let current = null, openStack = [], opener = null;
  let cart = { items: [], item_count: 0 };
  /* prices everywhere here are cents (Shopify's Cart/product Liquid convention), so money() divides by 100 */
  const money = (n) => 'Rs ' + Math.round(n / 100).toLocaleString('en-US');
  async function fetchCart() { return (await fetch('/cart.js')).json(); }
  async function addToCart(variantId) {
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || 'Could not add that to the bag.'); }
    return fetchCart();
  }
  async function removeFromCart(key) {
    await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    return fetchCart();
  }
  gsap.set([panel, bag], { xPercent: 102, x: 0 });

  function showLayer(el, from) {
    if (openStack.includes(el)) return;
    if (!openStack.length) { opener = from; gsap.to(scrim, { opacity: 1, duration: .6, pointerEvents: 'auto' }); }
    openStack.push(el);
    el.setAttribute('aria-hidden', 'false');
    gsap.set(el, { visibility: 'visible' });
    gsap.to(el, { xPercent: 0, duration: RM ? 0 : .8, ease: 'expo.inOut', onComplete: () => $('button', el).focus() });
  }
  function hideLayer(el) {
    if (!openStack.includes(el)) return;
    openStack = openStack.filter((x) => x !== el);
    el.setAttribute('aria-hidden', 'true');
    gsap.to(el, { xPercent: 102, duration: RM ? 0 : .7, ease: 'expo.inOut', onComplete: () => gsap.set(el, { visibility: 'hidden' }) });
    if (!openStack.length) { gsap.to(scrim, { opacity: 0, duration: .5, pointerEvents: 'none' }); opener?.focus(); }
    else $('button', openStack[openStack.length - 1]).focus();
  }
  function closeTop() { if (openStack.length) hideLayer(openStack[openStack.length - 1]); }
  scrim.addEventListener('click', () => { while (openStack.length) hideLayer(openStack[openStack.length - 1]); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') closeTop(); });
  [panel, bag].forEach((el) => el.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const f = $$('button, [href], input', el).filter((x) => !x.disabled && x.offsetParent !== null);
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }));

  $$('[data-piece]').forEach((card) => card.addEventListener('click', () => {
    current = { ...card.dataset, price: +card.dataset.price, variants: JSON.parse(card.dataset.variants || '{}') };
    $('#panel-img').src = current.img; $('#panel-img').alt = current.name;
    $('#panel-line').textContent = current.line;
    $('#panel-name').textContent = current.name;
    $('#panel-fabric').textContent = current.fabric;
    $('#panel-price').textContent = money(current.price);
    $('#panel-add').textContent = 'Add to bag';
    showLayer(panel, card);
  }));
  $('#panel-close').addEventListener('click', () => hideLayer(panel));
  $('#bag-close').addEventListener('click', () => hideLayer(bag));
  $('#bag-open').addEventListener('click', (e) => { renderBag(); showLayer(bag, e.currentTarget); });

  const countWrap = $('.count');
  function flipCount(n) {
    const old = $('#bag-count'), next = old.cloneNode(); next.textContent = n; old.removeAttribute('id'); countWrap.appendChild(next);
    if (RM) { old.remove(); return; }
    gsap.set(next, { yPercent: 100 });
    gsap.to(old, { yPercent: -100, duration: .6, ease: 'expo.inOut', onComplete: () => old.remove() });
    gsap.to(next, { yPercent: 0, duration: .6, ease: 'expo.inOut' });
  }
  function renderBag() {
    const list = $('#bag-list'); list.innerHTML = '';
    if (!cart.items.length) { const li = document.createElement('li'); li.className = 'bag__empty'; li.style.display = 'block'; li.textContent = 'Nothing in the bag yet.'; list.appendChild(li); }
    cart.items.forEach((it) => {
      const li = document.createElement('li');
      li.innerHTML = `<b>${it.product_title}</b><b class="mono">${money(it.final_line_price)}</b><span class="mono">${it.variant_title || ''}</span><button type="button" class="mono" data-remove="${it.key}">Remove</button>`;
      list.appendChild(li);
    });
    $('#bag-total').textContent = money(cart.total_price || 0);
    $('#bag-note').textContent = '';
  }
  $('#bag-list').addEventListener('click', async (e) => {
    const b = e.target.closest('[data-remove]'); if (!b) return;
    cart = await removeFromCart(b.dataset.remove);
    renderBag(); flipCount(cart.item_count);
  });
  $('#panel-add').addEventListener('click', async (e) => {
    if (!current) return;
    const size = $('#panel-sizes input:checked')?.value || 'M';
    const variantId = current.variants[size];
    if (!variantId) { $('#panel-price').textContent = 'That size isn’t available.'; return; }
    const btn = e.currentTarget;
    try {
      cart = await addToCart(variantId);
      flipCount(cart.item_count); btn.textContent = 'Added';
      renderBag(); showLayer(bag, btn);
    } catch (err) {
      btn.textContent = err.message || 'Sold out';
    }
  });
  $('#checkout').addEventListener('click', () => { $('#bag-note').textContent = 'Checkout connects to the payment provider once the first run is stocked.'; });
  fetchCart().then((c) => { cart = c; renderBag(); const el = $('#bag-count'); if (el) el.textContent = cart.item_count; });

  /* ---------- anchors ---------- */
  function goTo(href, e) {
    const target = $(href); if (!target) return;
    e?.preventDefault();
    if (lenis) { jumping = true; lenis.scrollTo(target, { offset: target.classList.contains('chapter') ? innerHeight : 0, duration: 1.6, easing: (t) => 1 - Math.pow(1 - t, 4), onComplete: () => { jumping = false; } }); }
    else target.scrollIntoView();
  }
  $$('a[href^="#"]:not([data-window])').forEach((a) => a.addEventListener('click', (e) => goTo(a.getAttribute('href'), e)));

  document.fonts.ready.then(() => { fitWordmark(); ScrollTrigger.refresh(); });
})();
  (function(){
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    if(!finePointer.matches) return;
    var dot = document.getElementById('cursorDot');
    var root = document.documentElement;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targetX = -100, targetY = -100, x = -100, y = -100;
    var ease = reduceMotion ? 1 : 0.28;
    var shown = false;
    var interactive = 'a, button, [role="button"], label, summary, select';
    var textual = 'input:not([type="radio"]):not([type="checkbox"]), textarea, [contenteditable="true"]';

    root.classList.add('has-dot-cursor');

    function render(){
      x += (targetX - x) * ease;
      y += (targetY - y) * ease;
      dot.style.left = x + 'px';
      dot.style.top = y + 'px';
      requestAnimationFrame(render);
    }

    document.addEventListener('mousemove', function(e){
      targetX = e.clientX;
      targetY = e.clientY;
      if(!shown){
        shown = true;
        x = targetX; y = targetY;
        dot.classList.add('is-visible');
      }
      var el = e.target;
      dot.classList.toggle('is-hover', !!(el.closest && el.closest(interactive)));
      dot.classList.toggle('is-text', !!(el.closest && el.closest(textual)));
    }, { passive: true });

    document.addEventListener('mousedown', function(){ dot.classList.add('is-down'); });
    document.addEventListener('mouseup', function(){ dot.classList.remove('is-down'); });
    document.addEventListener('mouseleave', function(){ dot.classList.remove('is-visible'); });
    document.addEventListener('mouseenter', function(){ if(shown) dot.classList.add('is-visible'); });
    window.addEventListener('blur', function(){ dot.classList.remove('is-visible'); });

    finePointer.addEventListener && finePointer.addEventListener('change', function(ev){
      root.classList.toggle('has-dot-cursor', ev.matches);
      if(!ev.matches) dot.classList.remove('is-visible');
    });

    requestAnimationFrame(render);
  })();
